import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import ShieldWithClock180ArrowIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithClock180Arrow';
import ShieldWithClock360ArrowIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithClock360Arrow';
import ShieldWithGlobe2ArrowsIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithGlobe2Arrows';
import ShieldWithGlobe3ArrowsIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithGlobe3Arrows';
// styles
import {
  ColStyled,
  ColStyledButtonContainer,
  RowStyled,
} from './styles';

const ITEMS = [
  {
    cardId: 'whole-life-link-card',
    icon: ShieldWithClock360ArrowIcon,
    cardHeading: 'Whole life insurance',
    cardText: (
      <>
        Be protected your entire life<sup>2</sup> and accumulate cash value that&#39;s guaranteed to grow year over year&#8212;no matter which way the markets go. Use the money for anything you need. You can help pay for your kids&#39; college, upgrade your home, expand your business, or have more retirement income.<sup>3</sup>
      </>
    ),
    linkUrl: '/life-insurance/whole-life-insurance/',
  },
  {
    cardId: 'universal-life-link-card',
    icon: ShieldWithGlobe2ArrowsIcon,
    cardHeading: 'Universal life insurance',
    cardText: (
      <>
        Get lifelong coverage<sup>2</sup> that gives you more flexibility now and down the road. You can change your payment amount (premiums) and schedule<sup>4</sup> to fit your life and budget, while still enjoying benefits that you can use throughout your life.
      </>
    ),
    linkUrl: '/life-insurance/universal-life-insurance/',
  },
  {
    cardId: 'variable-universal-life-link-card',
    icon: ShieldWithGlobe3ArrowsIcon,
    cardHeading: 'Variable universal life insurance',
    cardText: (
      <>
        You&#39;ll be protected throughout your life.<sup>2</sup> Plus, you get to choose how you want your policy&#39;s cash value to be invested in the markets.<sup>5</sup> This way, you can have the potential to increase its growth over time.
      </>
    ),
    linkUrl: '/life-insurance/variable-universal-life-insurance-vul/',
  },
  {
    cardId: 'term-life-link-card',
    icon: ShieldWithClock180ArrowIcon,
    cardHeading: 'Term life insurance',
    cardText: <>This is your simplest way to get started. You&#39;ll be covered for a set amount of time, like 10, 15, or 20 years. Once that term ends, so does your policy. But if your needs change along the way, you could have an opportunity to convert to lifelong coverage.</>,
    linkUrl: '/life-insurance/term-life-insurance/',
  },
];

export default () => (
  <SectionContainer
    id='life-insurance-product-callout-grouping'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          We have many types of life insurance policies to <WidowBlock>choose from</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <RowStyled align='center'>

      {ITEMS.map((item, index) => (
        <ColStyled
          key={`col-${item.cardId}`}
          medium={6}
          large={5}
          disableBottomPadding={(index + 1) === ITEMS.length} // disable bottom padding on last item
        >
          <ProductCard
            cardId={`product-callout-life-insurance-${item.cardId}`}
            icon={item.icon}
            backgroundVariant='lightB'
            cardHeading={item.cardHeading}
            cardText={item.cardText}
            linkId={`product-callout-life-insurance-${item.cardId}-link`}
            linkText='Find out more'
            linkUrl={item.linkUrl}
          />
        </ColStyled>
      ))}
    </RowStyled>
    <Row align='center'>
      <ColStyledButtonContainer>
        <Link
          id='product-callout-life-insurance-compare-products-link'
          variant='buttonLinkSecondary'
          linkUrl='/life-insurance/compare-types/'>
          Compare our types of insurance
        </Link>
      </ColStyledButtonContainer>
    </Row>
  </SectionContainer>
);
